module.exports = __webpack_public_path__ + "static/img/discord_logo.d8e77f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/discord_logo.png
// module id = DuPI
// module chunks = 1